import update from "immutability-helper";

import {
  ROLE_SELECTION_SHOW,
  ROLE_SELECTION_HIDE,
} from "@js/actions/mui/role_selection.js";

export default (state = {}, action) => {

  switch ( action.type ) {
  case ROLE_SELECTION_SHOW:
    return update(state, {
      showRoleSelectionModal: { $set: true },
    });
  case ROLE_SELECTION_HIDE:
    return update(state, {
      showRoleSelectionModal: { $set: false },
    });
  default:
    return state;
  }

};
